import { useCallback, useEffect } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { popModal } from '@/redux/modals/actions';
import { getLandingPageUrl } from '@/util/constants';

const ModalSmallScreen = () => {
  const { t } = useTranslation();
  const isSmallScreen = useBreakpoint('lg');

  const dispatch = useDispatch();

  const closeModal = useCallback(() => {
    dispatch(popModal());
  }, [dispatch]);

  // Close the modal once the viewport is no longer small.
  useEffect(() => {
    if (!isSmallScreen) {
      dispatch(popModal());
    }
  }, [dispatch, isSmallScreen]);

  return (
    <Dialog open onOpenChange={(open) => !open && closeModal()}>
      <DialogContent className="place-items-center gap-6 sm:max-w-[450px]">
        <img width={80} height={61} src="/assets/modals/small_screen_icon.svg" alt="" />

        <DialogHeader className="items-center sm:text-center">
          <DialogTitle className="max-w-[380px] text-center text-xl leading-7">
            {t('small_screen.title')}
          </DialogTitle>
          <DialogDescription className="text-center">
            {t('small_screen.subtitle')}
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="w-full flex-col gap-4 sm:flex-row">
          <Button className="w-full" asChild>
            <a href={getLandingPageUrl()}>
              <span>{t('small_screen.redirect')}</span>
            </a>
          </Button>
          <Button variant="ghost-neutral" onClick={closeModal} className="w-full">
            {t('small_screen.proceed')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ModalSmallScreen;
